const TOKEN_KEY = "adminToken";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

// Reads the `exp` claim without pulling in a JWT library.
//
// This is a UX check, never a security one: it exists so the app can send the
// user to the login screen instead of firing a request it knows will 401. The
// server verifies the signature, so a doctored token gains nothing here.
export function getTokenExpiry(token) {
  if (!token) return null;

  const payload = token.split(".")[1];
  if (!payload) return null;

  try {
    const decoded = JSON.parse(
      atob(payload.replace(/-/g, "+").replace(/_/g, "/"))
    );
    return typeof decoded.exp === "number" ? decoded.exp * 1000 : null;
  } catch {
    return null;
  }
}

// A token with no readable expiry is treated as usable — the server is the
// authority and will reject it if it isn't.
export function isTokenValid(token = getToken()) {
  if (!token) return false;

  const expiresAt = getTokenExpiry(token);
  return expiresAt === null ? true : expiresAt > Date.now();
}
